/* ============================================================================
   recipe.js  —  Vitantonio レシピページ・リニューアル（案B-改）
   ----------------------------------------------------------------------------
   依存ライブラリ無し・素のJS。最小限のフックのみ。
   - ヒーローのサムネ切替（data-hero-thumb → data-hero-slide 表示切替）
   - 使用ツールのカルーセル（商品が横スクロール可能な数の時、矢印操作を付与）
   - JSフックは data-recipe-* / data-hero-* / data-tools-* 属性のみを参照する
     （class はスタイル専用。両者を混用しない）
   - FAQ は <details>/<summary> ネイティブ、材料チェックは checkbox ネイティブ
     のため JS 不要。
   ============================================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---- 1. ヒーロー サムネ/矢印/スワイプ切替 ------------------------------ */
  function initHero(root) {
    var thumbsWrap = root.querySelector('[data-hero-thumbs]');
    var mainWrap = root.querySelector('[data-hero-main]');
    if (!thumbsWrap || !mainWrap) { return; }

    var slides = Array.prototype.slice.call(mainWrap.querySelectorAll('[data-hero-slide]'));
    var buttons = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-hero-thumb]'));
    var navButtons = Array.prototype.slice.call(root.querySelectorAll('[data-hero-nav]'));
    if (!slides.length || !buttons.length) { return; }
    var currentIndex = buttons[0].getAttribute('data-hero-thumb') || '0';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var heightTimer = null;

    function getButtonPos(index) {
      return buttons.findIndex(function (btn) {
        return btn.getAttribute('data-hero-thumb') === String(index);
      });
    }

    function getVisibleSlide() {
      return slides.find(function (slide) { return !slide.hidden; });
    }

    function cleanupHeight() {
      window.clearTimeout(heightTimer);
      mainWrap.classList.remove('is-height-animating');
      mainWrap.style.height = '';
    }

    function animateHeight(fromHeight) {
      if (reduceMotion || !fromHeight) { return; }
      var visible = getVisibleSlide();
      if (!visible) { cleanupHeight(); return; }
      var toHeight = visible.getBoundingClientRect().height;
      if (!toHeight || Math.abs(toHeight - fromHeight) < 2) { cleanupHeight(); return; }
      mainWrap.classList.add('is-height-animating');
      window.requestAnimationFrame(function () {
        mainWrap.style.height = toHeight + 'px';
      });
      window.clearTimeout(heightTimer);
      heightTimer = window.setTimeout(cleanupHeight, 520);
    }

    function show(index, direction) {
      var nextIndex = String(index);
      var hasMatch = slides.some(function (slide) {
        return slide.getAttribute('data-hero-slide') === nextIndex;
      });
      if (!hasMatch) { return; }
      if (!direction) {
        var fromPos = getButtonPos(currentIndex);
        var toPos = getButtonPos(nextIndex);
        direction = toPos < fromPos ? 'prev' : 'next';
      }
      mainWrap.setAttribute('data-hero-direction', direction);
      var fromHeight = mainWrap.getBoundingClientRect().height;
      if (!reduceMotion && fromHeight) {
        mainWrap.classList.remove('is-height-animating');
        mainWrap.style.height = fromHeight + 'px';
        mainWrap.offsetHeight;
      }
      currentIndex = nextIndex;
      slides.forEach(function (slide) {
        var match = slide.getAttribute('data-hero-slide') === currentIndex;
        slide.hidden = !match;
        if (!match && slide.tagName === 'VIDEO') { slide.pause(); }
      });
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-hero-thumb') === currentIndex;
        btn.classList.toggle('is-active', active);
        if (active) { btn.setAttribute('aria-current', 'true'); }
        else { btn.removeAttribute('aria-current'); }
      });
      animateHeight(fromHeight);
    }

    function move(delta) {
      var pos = buttons.findIndex(function (btn) {
        return btn.getAttribute('data-hero-thumb') === currentIndex;
      });
      if (pos < 0) { pos = 0; }
      var nextPos = (pos + delta + buttons.length) % buttons.length;
      show(buttons[nextPos].getAttribute('data-hero-thumb'), delta < 0 ? 'prev' : 'next');
    }

    thumbsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hero-thumb]');
      if (!btn) { return; }
      show(btn.getAttribute('data-hero-thumb'));
    });

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        move(btn.getAttribute('data-hero-nav') === 'prev' ? -1 : 1);
      });
    });

    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeTracking = false;
    mainWrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) { return; }
      swipeStartX = e.clientX;
      swipeStartY = e.clientY;
      swipeTracking = true;
    });
    mainWrap.addEventListener('pointerup', function (e) {
      if (!swipeTracking) { return; }
      swipeTracking = false;
      var dx = e.clientX - swipeStartX;
      var dy = e.clientY - swipeStartY;
      if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy) * 1.25) { return; }
      move(dx < 0 ? 1 : -1);
    });
    mainWrap.addEventListener('pointercancel', function () { swipeTracking = false; });

    // 初期表示: index 0
    show(0);
  }

  /* ---- 2. 使用ツール カルーセル ---------------------------------------- */
  /* 統合先テーマの既存 CSS は product-list を
     `display:grid !important; flex-wrap:wrap !important; width:100% !important`
     に固定しているため、商品が増えても横に溢れず多段ラップする＝横スクロールは起きない。
     そこで「商品が一定数以上（=横カルーセルにする意味がある）」のときだけ
     .is-carousel を付けて recipe.css 側で横スクロール flex に切り替え、ドラッグ補助を付ける。
     少数（グリッドで収まる）のときはグリッド表示のまま何もしない。 */
  var CAROUSEL_MIN_ITEMS = 5;

  /* ドットページネーション（実際に横スクロールできる「ページ」数だけ生成） */
  function buildDots(list) {
    var cards = Array.prototype.slice.call(list.children);
    if (cards.length < 2) { return; }
    var nav = document.createElement('div');
    nav.className = 'recipe__tools-nav';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'recipe__tools-arrow recipe__tools-arrow--prev';
    prev.setAttribute('aria-label', '前のページへ');
    var dotsNav = document.createElement('div');
    dotsNav.className = 'recipe__tools-dots';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'recipe__tools-arrow recipe__tools-arrow--next';
    next.setAttribute('aria-label', '次のページへ');
    nav.appendChild(prev); nav.appendChild(dotsNav); nav.appendChild(next);
    var dots = [];
    var targets = [];

    function calculateTargets() {
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      if (maxScroll <= 1) { return [0]; }
      var baseLeft = cards[0].offsetLeft;
      var cardPositions = cards.map(function (card) { return card.offsetLeft - baseLeft; });
      var nextTargets = [0];
      var guard = 0;
      while (nextTargets[nextTargets.length - 1] < maxScroll - 1 && guard < cards.length) {
        var desired = nextTargets[nextTargets.length - 1] + list.clientWidth;
        var next = maxScroll;
        for (var i = 0; i < cardPositions.length; i += 1) {
          if (cardPositions[i] >= desired - 1) { next = Math.min(cardPositions[i], maxScroll); break; }
        }
        if (next <= nextTargets[nextTargets.length - 1] + 1) { next = maxScroll; }
        nextTargets.push(next);
        guard += 1;
      }
      return nextTargets;
    }
    function currentPage() {
      var sl = list.scrollLeft, best = 0, bd = Infinity;
      targets.forEach(function (target, i) { var d = Math.abs(target - sl); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function sync() {
      var best = currentPage();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      prev.disabled = best === 0;
      next.disabled = best === targets.length - 1;
    }
    function rebuild() {
      targets = calculateTargets();
      dotsNav.innerHTML = '';
      dots = [];
      if (targets.length <= 1) {
        if (nav.parentNode) { nav.parentNode.removeChild(nav); }
        return;
      }
      targets.forEach(function (target, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'recipe__tools-dot';
        b.setAttribute('aria-label', (i + 1) + 'ページ目へ');
        b.addEventListener('click', function () { list.scrollTo({ left: target, behavior: 'smooth' }); });
        dotsNav.appendChild(b); dots.push(b);
      });
      if (!nav.parentNode) { list.parentNode.appendChild(nav); }
      sync();
    }
    prev.addEventListener('click', function () {
      var index = Math.max(0, currentPage() - 1);
      list.scrollTo({ left: targets[index], behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      var index = Math.min(targets.length - 1, currentPage() + 1);
      list.scrollTo({ left: targets[index], behavior: 'smooth' });
    });
    var raf = 0;
    list.addEventListener('scroll', function () { if (raf) { return; } raf = requestAnimationFrame(function () { raf = 0; sync(); }); });
    var resizeRaf = 0;
    function scheduleRebuild() {
      if (resizeRaf) { cancelAnimationFrame(resizeRaf); }
      resizeRaf = requestAnimationFrame(function () { resizeRaf = 0; rebuild(); });
    }
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(scheduleRebuild);
      observer.observe(list);
    } else {
      window.addEventListener('resize', scheduleRebuild);
    }
    rebuild();
  }

  function initToolsCarousel(list) {
    if (!list) { return; }
    var items = list.children;
    /* 使用ツール（上）= 2件以上で常にカルーセル。下（価格/評価カード）は従来どおり多数時のみ。 */
    var isTop = !!(list.closest && list.closest('.recipe__tools--top'));
    var minItems = isTop ? 2 : CAROUSEL_MIN_ITEMS;
    if (items.length < minItems) { return; }

    // 横スクロール表示へ切替（CSS が .is-carousel を受けて flex/overflow を適用）
    list.classList.add('is-carousel');

    var isDown = false, startX = 0, startScroll = 0, moved = false, suppressClick = false;
    var activePointerId = null;

    list.classList.add('is-draggable');
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) { return; }
      isDown = true; moved = false;
      suppressClick = false;
      activePointerId = e.pointerId;
      startX = e.clientX;
      startScroll = list.scrollLeft;
    });
    list.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerId !== activePointerId) { return; }
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) <= 6) { return; }
      if (!moved) {
        moved = true;
        list.classList.add('is-dragging');
        try { list.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
      list.scrollLeft = startScroll - dx;
    });
    function end(e) {
      if (!isDown || e.pointerId !== activePointerId) { return; }
      suppressClick = moved;
      isDown = false;
      activePointerId = null;
      list.classList.remove('is-dragging');
      try {
        if (list.hasPointerCapture && list.hasPointerCapture(e.pointerId)) { list.releasePointerCapture(e.pointerId); }
      } catch (err) {}
    }
    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', function (e) { end(e); suppressClick = false; });
    // ドラッグ後の意図しないリンク発火を抑止
    list.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; moved = false; }
    }, true);

    buildDots(list);
  }

  /* ---- 3. 材料チェックの保存（localStorage） ------------------------------ */
  function initIngredientPersistence(root) {
    var boxes = root.querySelectorAll('.recipe__ingredient-check');
    if (!boxes.length) { return; }
    var key = 'recipe-checks:' + (root.getAttribute('data-handle') || location.pathname);
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(key) || '{}'); } catch (e) {}
    function save() {
      var cur = {};
      boxes.forEach(function (b, i) { if (b.checked) { cur[i] = 1; } });
      try { localStorage.setItem(key, JSON.stringify(cur)); } catch (e) {}
    }
    boxes.forEach(function (b, i) {
      if (saved[i]) { b.checked = true; }
      b.addEventListener('change', save);
    });
  }

  /* ---- 4. 印刷・共有 ------------------------------------------------------ */
  function initActions(root) {
    root.querySelectorAll('[data-recipe-print]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); window.print(); });
    });
    root.querySelectorAll('[data-recipe-share]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var payload = { title: document.title, url: location.href };
        if (navigator.share) { navigator.share(payload).catch(function () {}); return; }
        var label = btn.querySelector('.recipe__action-text');
        function flash(msg) { if (!label) { return; } var o = label.textContent; label.textContent = msg; setTimeout(function () { label.textContent = o; }, 1600); }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(location.href).then(function () { flash('URLをコピーしました'); }).catch(function () { flash('コピーできませんでした'); });
        }
      });
    });
  }

  /* ---- 5. ライトボックス（手順メディア拡大） ----------------------------- */
  function initLightbox(root) {
    var box = root.querySelector('[data-recipe-lightbox]');
    if (!box) { return; }
    var body = box.querySelector('[data-recipe-lightbox-body]');
    var lastFocus = null;
    function close() {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      body.innerHTML = '';
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }
    function open(node) {
      body.innerHTML = '';
      var big;
      if (node.tagName === 'VIDEO') {
        big = document.createElement('video');
        big.className = 'recipe__lightbox-media';
        big.setAttribute('controls', '');
        big.setAttribute('playsinline', '');
        big.setAttribute('autoplay', '');
        if (node.getAttribute('poster')) { big.setAttribute('poster', node.getAttribute('poster')); }
        var src = node.querySelector('source');
        if (src) { var s = document.createElement('source'); s.src = src.src; s.type = src.type; big.appendChild(s); }
        else { big.src = node.currentSrc || node.src; }
      } else {
        big = document.createElement('img');
        big.className = 'recipe__lightbox-media';
        big.src = node.currentSrc || node.src;
        big.alt = node.alt || '';
      }
      body.appendChild(big);
      lastFocus = document.activeElement;
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = box.querySelector('[data-recipe-lightbox-close]');
      if (closeBtn) { closeBtn.focus(); }
    }
    root.querySelectorAll('.recipe__step-media').forEach(function (m) {
      m.addEventListener('click', function (e) {
        e.preventDefault();
        var node = m.querySelector('video') || m.querySelector('img') || m;
        open(node);
      });
    });
    box.querySelectorAll('[data-recipe-lightbox-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    box.addEventListener('click', function (e) { if (e.target === box) { close(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) { close(); } });
  }

  /* ---- init ------------------------------------------------------------ */
  ready(function () {
    var roots = document.querySelectorAll('[data-recipe]');
    roots.forEach(function (root) {
      initHero(root);
      root.querySelectorAll('[data-tools-carousel]').forEach(initToolsCarousel);
      initIngredientPersistence(root);
      initActions(root);
      initLightbox(root);
    });
  });
})();
